import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BookDemoLink from "../../components/bookdemo/BookDemoLink";
import Text from "../../components/ui/Text";
import Touchable from "../../components/ui/Touchable";
import useStore from "../../hooks/store/useStore";
import { EventTrackingSourcePageType } from "../../services/EventTracking/types";
import Button from "./components/Button";
import getBookDemoImageUrl from "./utils/getBookDemoImageUrl";
import BookDemoFormJP from "./BookDemoFormJP";

export default function BookDemoIntroJP({
  sourcePage,
}: {
  sourcePage: EventTrackingSourcePageType;
}) {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);

  const { showBookDemoDrawer } = useStore((state) => state.bookDemo);
  const { userInformation } = useStore((state) => state.user);
  const { userName, market, leadNo } = userInformation || {};
  const imageUrl = getBookDemoImageUrl(market);

  useEffect(() => {
    if (!showBookDemoDrawer) setShowForm(false);
  }, [showBookDemoDrawer]);

  if (showForm && leadNo) return <BookDemoFormJP leadNo={leadNo} />;

  return (
    <div className="flex w-full flex-col items-center gap-10 px-10 pb-6">
      <div className="flex max-w-[310px] flex-col gap-3">
        <Text className="text-xl text-grey8">{t("bookDemoTitle")}</Text>

        <Text normal>{userName + t("bookDemoDesc1")}</Text>
        <Text normal>{t("bookDemoDesc2")}</Text>

        <div className="flex w-full justify-center">
          <img src={imageUrl} alt="cover" className="w-[310px] rounded" />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {leadNo ? (
          <Button
            text={t("bookDemoAction")}
            onClick={() => setShowForm(true)}
          />
        ) : (
          // No event tracking for this link because BookButton was triggered already
          <BookDemoLink sourcePage={sourcePage} shouldEventTracking={false}>
            <Button text={t("bookDemoAction")} onClick={() => {}} />
          </BookDemoLink>
        )}
        <div className="flex h-[48px] w-full items-center justify-center">
          <Touchable>
            <Text>{"無料体験を受けた人の声を見る"}</Text>
          </Touchable>
        </div>
      </div>
    </div>
  );
}
